import React, { useEffect, useState } from 'react'
import useActiveState from '../../../lib/useActiveState'
import { RightOutlined } from '@ant-design/icons'
import { useSelectAccount } from './SelectAccount'
import { NavLink } from '../../../lib/Navigation'

export default function XHInfo(props) {

  const [user] = useActiveState('user')
  const { selectAccountInfo } = useSelectAccount()
  const [xh, setXH] = useState({})

  useEffect(() => {
    setXH(props.xh)
  }, [props.xh])

  useEffect(() => {
    setXH(selectAccountInfo)
  }, [selectAccountInfo])

  return (
    <div style={{
      backgroundColor: '#DCE9FE',
      padding: '10px 15px',
      position: 'fixed',
      top: 'calc(env(safe-area-inset-top) + 40px)',
      left: '0',
      right: '0',
      zIndex: '9',
      maxWidth:'720px',
      margin:'0 auto'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: '14px', color: '#282828' }}>
          {user.isLogin ? (props.list?.length > 0 ? `${xh?.alias}` : `请先下载游戏登录后再领取${props.title}`) : '请登录账号，领取你的福利'}
        </div>
        {user.isLogin ? (
          props.list?.length > 1 ?
            <div onClick={() => {
              if (props.change) {
                props.change()
              }
            }} style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ fontSize: '14px', color: '#666' }}>切换</div>
              <RightOutlined style={{fontSize:'11px',color:'#666'}}></RightOutlined>
            </div> : null
        )
          :
          <NavLink style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ fontSize: '14px', color: '#666' }}>立即登录</div>
            <RightOutlined ></RightOutlined>
          </NavLink>}
      </div>
    </div>
  )
}
